<template>
  <div>
    <div v-if="type === 'A'">
      <iframe :src="url" frameborder="0" width="100%" :height="height"></iframe>
    </div>
    <div v-if="type === 'C'">
      <mu-dialog :open="true">
        <h3>即將前往以下網站：</h3>
        <div>{{ domain }}</div>
        <p>請點擊 "確認" 以繼續</p>
        <mu-button slot="actions" flat color="primary" @click="goBack">返回</mu-button>
        <mu-button slot="actions" color="primary" @click="gotoPage">確認</mu-button>
      </mu-dialog>
    </div>
    <!-- 選擇品項 -->
    <div v-else-if="page === 1" :style="{ overflowY: 'auto', height: `${height}px`, paddingTop: 10 + 'px' }">
      <div v-for="(item, index) in linkArr" :key="index + 'l'" class="itemBox">
        <el-row :gutter="3">
          <el-col :span="15">
            <div style="font-size: 16px; font-weight: 500; line-height: 80px;">{{ item.name }}</div>
          </el-col>
          <el-col :span="9">
            <div>
              <div class="btn" @click="getLink(item)">
                <i class="el-icon-shopping-cart-2" style="margin-right: 3px;"></i>前往選購
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 內嵌官網 -->
    <div v-else>
      <iframe :src="linkUrl" frameborder="0" width="100%" :height="height * 0.88"></iframe>
      <div style="text-align: left; padding-left: 8px;">
        <el-button type="info" icon="el-icon-d-arrow-left" @click="page = 1">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';


export default {
  data() {
    return {
      dialog: true,
      page: 1,
      linkUrl: '',
      height: 300,
      domain: '',
      service: this.$route.params.service,
    };
  },
  props: ['type', 'url', 'webHeight', 'linkArr', 'auth'],
  computed: {
    ...mapGetters({
      userpoints: 'userpoints'
    })
  },
  mounted() {
    this.height = (this.service === 'FB') ? this.webHeight * 0.63 : this.webHeight * 0.68;
    if (this.type === 'A') {
      const userCode = this.checkParam(this.url, 'user');
      this.setLoading();
      this.recordLogin({ userCode, clientId: this.auth });
    }
    if (this.type === 'C') {
      const domain = 'http' + this.url.split('http')[1].split('?user')[0]
      this.domain = domain;
    }
  },
  methods: {
    ...mapActions({
      recordLogin: 'recordLogin'
    }),
    gotoPage() {
      window.open(this.url);
    },
    checkParam(url, str) {
      if (url.split(`&${str}=`)[1]) {
        return url.split(`&${str}=`)[1].split('&')[0];
      }
      else if (url.split(`?${str}=`)[1]) {
        return url.split(`?${str}=`)[1].split('&')[0];
      }
      else {
        return '';
      }
    },
    setLoading() {
      const loading = this.$loading({
        lock: true, text: 'Loading', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 1000);
    },
    goBack() {
      window.location.reload();
    },
    getLink(item) {
      this.setLoading();
      this.linkUrl = item.url;
      this.page = 2;
    }
  }
}
</script>

<style scoped>
  .itemBox {
    border: 1px solid #eee;
    padding: 0px 20px;
    text-align: left;
    height: 80px;
  }
  .btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-weight: 600;
    padding: 7px 14px;
    padding-left: 10px;
    background-color: #337ab7;
    border-radius: 8px;
  }
</style>